import React, { useState } from 'react';
import { MessageCircleIcon, XIcon } from 'lucide-react';
export const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-343">
      {isOpen && <div className="bg-white text-black p-4 rounded-lg shadow-xl mb-4 w-64 animate-fade-in" data-id="element-344">
          <div className="flex justify-between items-center mb-3" data-id="element-345">
            <h3 className="font-semibold" data-id="element-346">WhatsApp Contact</h3>
            <button onClick={() => setIsOpen(false)} className="text-gray-500 hover:text-gray-700" data-id="element-347">
              <XIcon size={16} data-id="element-348" />
            </button>
          </div>
          <p className="text-sm text-gray-600 mb-3" data-id="element-349">
            Stuur ons direct een bericht via WhatsApp voor snelle assistentie.
          </p>
          <a href="https://wa.me/31651764541" target="_blank" rel="noopener noreferrer" className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded text-sm font-medium flex items-center justify-center" data-id="element-350">
            Start WhatsApp Chat
          </a>
        </div>}
      <button onClick={() => setIsOpen(!isOpen)} className="bg-white p-0 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 overflow-hidden" data-id="element-351">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oaayZ1C3T6hEUgC4rFSL18/15707917_%281%29.png" alt="WhatsApp Contact Knop - Blue Rain Productions" className="w-14 h-14 object-cover" data-id="element-352" />
      </button>
    </div>;
};